<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <span>{{ title }}</span>
  <span class="spacer"></span>
  <mat-icon (click)="showRules()">help</mat-icon>
</mat-toolbar>

<div class="home-wrapper">
  <!-- ── Hero ─────────────────────────────────────────────── -->
  <div class="hero">
    <div class="hero-bg"></div>
    <div class="hero-content">
      <div class="avatar-ring">
        <app-avatar [user]="user"></app-avatar>
        @if (isMe || isAdmin) {
          <input
            type="file"
            (change)="fileBrowseHandler($event)"
            name="avatar"
          />
        }
      </div>
      <h1 class="hero-name">{{ user?.name || user?.email }}</h1>
      @if (standings) {
        <span class="hero-rank">
          <mat-icon>emoji_events</mat-icon>
          {{ standings.pos }}ª posición
        </span>
      }
      <button class="hero-standings-btn" (click)="showStandings()">
        <mat-icon>format_list_numbered</mat-icon>
        Ver clasificación
      </button>
    </div>
  </div>

  <!-- ── Body ─────────────────────────────────────────────── -->
  <div class="home-body">
    <!-- Stats -->
    <div class="stats-row" (click)="showPoll()">
      <div class="stat-item">
        <span class="stat-value">{{ standings?.points }}</span>
        <span class="stat-label">Puntos</span>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-item">
        <span class="stat-value">{{ standings?.matchesOk }}</span>
        <span class="stat-label">Aciertos</span>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-item">
        <span class="stat-value">{{ standings?.sniper }}</span>
        <span class="stat-label">Dianas</span>
      </div>
    </div>

    @if (user) {
      <!-- Predictions card -->
      <div class="section-label">Pronósticos especiales</div>
      <div class="predictions-card" (click)="showPoll()">
        <!-- Champion -->
        <div class="prediction-item">
          <span class="prediction-tag">Campeón</span>
          @if (isMe || currentTimestamp >= firstRoundIniTimestamp) {
            <div class="prediction-flag">
              @if (user.champion) {
                <img [src]="user.champion.flag" [alt]="user.champion.name" />
              } @else {
                <img src="assets/imgs/logo.png" alt="Sin seleccionar" />
              }
              @if (user.champion?._id === finalResult?.team._id) {
                <span class="check-badge"
                  ><mat-icon>check_circle</mat-icon></span
                >
              }
            </div>
            <span class="prediction-name">
              @if (user.champion) {
                {{ user.champion.name }}
              } @else if (isMe) {
                <span
                  class="configure-hint"
                  (click)="showChampion(); $event.stopPropagation()"
                  >Configurar</span
                >
              } @else {
                —
              }
            </span>
          } @else {
            <div class="prediction-flag locked">
              <img src="assets/imgs/logo.png" alt="" />
            </div>
            <span class="prediction-name muted">¡Espera al inicio!</span>
          }
        </div>

        <div class="pred-divider"></div>

        <!-- Pichichi -->
        <div class="prediction-item">
          <span class="prediction-tag">Pichichi</span>
          @if (isMe || currentTimestamp >= firstRoundIniTimestamp) {
            <div class="prediction-flag">
              @if (pichiciPlayer?.team?.flag) {
                <img
                  [src]="pichiciPlayer.team.flag"
                  [alt]="pichiciPlayer.team.name"
                />
              } @else {
                <img src="assets/imgs/pichichi.png" alt="Pichichi" />
              }
              @if (user?.pichichi && user?.pichichi === finalResult?.pichichi) {
                <span class="check-badge"
                  ><mat-icon>check_circle</mat-icon></span
                >
              }
            </div>
            <span class="prediction-name">
              @if (pichiciPlayer) {
                {{ pichiciPlayer.name }}
              } @else if (isMe) {
                <span
                  class="configure-hint"
                  (click)="showChampion(); $event.stopPropagation()"
                  >Configurar</span
                >
              } @else {
                —
              }
            </span>
          } @else {
            <div class="prediction-flag locked">
              <img src="assets/imgs/pichichi.png" alt="" />
            </div>
            <span class="prediction-name muted">¡Espera al inicio!</span>
          }
        </div>
      </div>

      <!-- CTA -->
      <button class="cta-btn" (click)="showPoll()">
        <mat-icon>bar_chart</mat-icon>
        Ver todos los resultados
      </button>
    }
  </div>
</div>
